import React, { useState, useEffect } from 'react'
import { makeStyles } from '@material-ui/core'
import { RadioOff, RadioOn } from './Icons'

const useStyles = makeStyles({
  radioShowState: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
  },
  radioItem: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
    cursor: 'pointer',
  },
  radioItemTitle: {
    marginLeft: 8,
    color: '#181818',
    fontSize: 12,
    lineHeight: '18px',
    fontWeight: 'normal',
  },
  radioIcons: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    width: 16,
    height: 16,
  },
})

interface RadioToggleProps {
  list: any
  getActiveValue: any
  activeItemDefault: any
}

const RadioToggle = ({
  list,
  getActiveValue,
  activeItemDefault,
}: RadioToggleProps) => {
  const classes = useStyles()
  const [activeItem, setActiveItem] = useState(activeItemDefault)

  const onClickItem = (item: any) => {
    setActiveItem(item)
    getActiveValue(item)
  }

  useEffect(() => {
    setActiveItem(activeItemDefault)
  }, [activeItemDefault])

  return (
    <div className={classes.radioShowState}>
      {list.map((item: any, index: any) => (
        <div
          onClick={() => onClickItem(item)}
          key={item.id}
          className={classes.radioItem}
          style={{
            marginRight: `${index === list.length - 1 ? '0px' : '16px'}`,
          }}
        >
          <div className={classes.radioIcons}>
            {JSON.stringify(activeItem) === JSON.stringify(item) ? (
              <RadioOn />
            ) : (
              <RadioOff />
            )}
          </div>
          <span className={classes.radioItemTitle}>{item.value}</span>
        </div>
      ))}
    </div>
  )
}

export default RadioToggle
